export const positions = {
    bottomLeft: {
        initial: {
            right: 0
        },
        to: {
            top: 'calc(100% + 4px)'
        }
    },
    bottomRight: {
        initial: {
            left: 0
        },
        to: {
            top: 'calc(100% + 4px)'
        }
    },
    topLeft: {
        initial: {
            right: 0
        },
        to: {
            bottom: 'calc(100% + 4px)'
        }
    },
    topRight: {
        initial: {
            left: 0
        },
        to: {
            bottom: 'calc(100% + 4px)'
        }
    },
    headerFixed: {
        initial: {
            left: 0
        },
        to: {
            top: '68px',
            height: 'calc(100dvh - 68px)',
            width: '100vw'
        }
    },
    headerFixedAll: {
        initial: {
            left: 0
        },
        to: {
            top: '0px',
            height: '100vh',
            width: '100vw'
        }
    }
};
